import React from 'react';
import { Wrapper, Container } from './style';
import { getNoToken } from '../../utils/request';
import { Toast } from 'antd-mobile';
import Config from '../../config';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import bg_smll_01 from '../../assets/images/bg_smll_01.png';
import bg_smll_02 from '../../assets/images/bg_smll_02.png';
import icon_delete from '../../assets/images/icon_delete.png';
import icon_pgy from '../../assets/images/icon_pgy.png';
import img_code from '../../assets/images/img_code.png';

class Home1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowComponent: false,
      staticInfo: {}
    }
  }
  async componentDidMount() {
    document.title = '水母来了-蒲公英计划'
    await this.loadStaticInfo()
    let res = await this.loadWxConfig();
    if(res.data.code == 100){
      window.wx.config({
        debug: false,
        ...res.data.data,
        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData']
      });
    } else {
      Toast.info('配置微信分享异常')
    }
    window.wx.ready(() => {
      //分享朋友圈
      window.wx.onMenuShareTimeline({
        title: this.state.staticInfo.shareTitle || '蒲公英计划',
        link: `${Config.HTTP_HOST_SMLL}/home1`, 
        imgUrl: this.state.staticInfo.shareImg || 'https://img.bangivf.com/static/pgy/share-202192-173624.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.onMenuShareAppMessage({
        title: this.state.staticInfo.shareTitle || '蒲公英计划',
        desc: this.state.staticInfo.shareDesc || '一边帮助她人一边赚钱养家',
        link: `${Config.HTTP_HOST_SMLL}/home1`,
        imgUrl: this.state.staticInfo.shareImg || 'https://img.bangivf.com/static/pgy/share-202192-173624.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
      //分享朋友圈
      window.wx.updateTimelineShareData({
        title: this.state.staticInfo.shareTitle || '蒲公英计划',
        link: `${Config.HTTP_HOST_SMLL}/home1`,
        imgUrl: this.state.staticInfo.shareImg || 'https://img.bangivf.com/static/pgy/share-202192-173624.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.updateAppMessageShareData({
        title: this.state.staticInfo.shareTitle || '蒲公英计划',
        desc: this.state.staticInfo.shareDesc || '一边帮助她人一边赚钱养家',
        link: `${Config.HTTP_HOST_SMLL}/home1`,
        imgUrl: this.state.staticInfo.shareImg || 'https://img.bangivf.com/static/pgy/share-202192-173624.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
    })
  }
  async loadWxConfig(){
    let appid = Config.appId
    let url = window.location.href.split('#')[0]
    let params = {appid, url}
    let res = await getNoToken(`/pgy/user/${Config.appId}/jsapiTicket`, params)
    return res
  }
  async loadStaticInfo(){
    let res = await getNoToken(`/pgy/user/${Config.appId}/appInitConfig`)
    console.log(res)
    this.setState({staticInfo: res.data.data})
  }
  showComponent = e => {
    e.stopPropagation()
    this.setState({isShowComponent: true})
  }
  hideComponent = e => {
    e.stopPropagation()
    this.setState({isShowComponent: false})
  }
  clickComponentMain = e => {
    e.stopPropagation()
  }
  onCopy(){
    Toast.info('复制成功')
  }
  render() {
    let { isShowComponent,staticInfo } = this.state;
    return (
      <Wrapper>
        <Container>
          <img className="bg1" src={bg_smll_01} />
          <img className="bg2" src={bg_smll_02} />
          <div className="text">
            <div>规则说明</div>
            <p> 一、什么是蒲公英计划？</p>
            <span>
              “蒲公英计划“是希望通过我们专业的医疗服务和感动服务，让您认同我们，一起帮助更多有需要的家庭和姐妹，
              就像蒲公英般坚韧又充满顽强生命力的扩散式传播。所有朋友都可以加入我们蒲公英计划，我们希望您是充满爱心和正能量的蒲公英。
              对于每一位蒲公英的辛苦付出，我们都会给予到相应奖励。
            </span>
            <p>二、什么是蒲公英等级？</p>
            <span>
              1、我们的老朋友（成交客户），帮助人数5个以内，我们称之为“白蒲公英”；<br/>
              2、我们的老朋友（成交客户），帮助人数5个以上（不包含5个），我们称之为“紫蒲公英”；<br/>
              3、我们的新朋友（未成交客户或意向客户），我们称之为“黄蒲公英”。
            </span>
            <p>三、蒲公英计划奖金说明</p>
            <span>
              1、蒲公英奖金<br/>
                &nbsp;&nbsp;&nbsp;邀请的朋友签约成功后，即可获得<br/>
              （1）白蒲公英奖励金额为2000元/人<br/>
              （2）紫蒲公英奖励金额为3000元/人（从第6人开始进行计算）<br/>
              （3）黄蒲公英奖励金额为2000元/人
            </span>
            <span>
              2、新朋友优惠金<br/>
              白蒲公英或紫蒲公英帮助的新朋友，签约任一套餐，直接优惠2000元
            </span>
            <span>
              3、辅导成长奖金<br/>
              （1）我们鼓励蒲公英帮助新朋友，也同时鼓励蒲公英邀请新朋友也加入蒲公英计划，我们称之为发展下级<br/>
              （2）蒲公英发展下级，我们为此设立辅导成长奖金，对下只保留一级，下级邀请的朋友签约成功即可获得辅导成长奖，奖金为1000元/人，不限制人数
            </span>
            <p>四、奖金发放规则说明</p>
            <span>
              （1）请每位参加蒲公英计划的朋友将银行卡/支付宝账户信息提交至“个人中心”；<br/>
              （2）客户签约成功次月10-15号，由我司财务统一进行奖金发放
            </span>
            <p>五、如何查看蒲公英计划推广进度？</p>
            <span>
              点击公众号菜单里的“个人中心”即可查看。
            </span>
            <p>六、其他说明</p>
            <span>
              解释权为我司所有，未尽事宜由我司进行后续完善优化。
            </span>
          </div>
          
          <div className={`component ${isShowComponent?'show':'hide'}`} onClick={this.hideComponent}>
            <div className="componentor" onClick={this.clickComponentMain}>
              <div className="bg_01">
                <span>THE DANDELION</span>
                <span>PROJECT</span>
              </div>
              <div className="bg_02">
                <div className="title">
                  <img src={icon_pgy} />
                  <span>我是老朋友</span>
                  <img src={icon_pgy} />
                </div>
                <p className="msg">请直接联系您的销售人员，即可加入蒲公英计划</p>
              </div>
              <div className="bg_03">
                <div className="title">
                  <img src={icon_pgy} />
                  <span>我是新朋友</span>
                  <img src={icon_pgy} />
                </div>
                <p className="msg">请添加工作人员微信，即可加入蒲公英计划，您可以通过查找手机号码添加好友</p>
                <p className="phone"> 
                  <span>{staticInfo.csWx}</span>
                  <CopyToClipboard text={staticInfo.csWx} onCopy={this.onCopy}><b>复制</b></CopyToClipboard>
                </p>
                <p className="msg">也可以长按图片识别二维码添加好友</p>
                <img className="code" src={staticInfo.csQrcode} />
              </div>
            </div>
            <div className="close">
              <img src={icon_delete} />
            </div>
          </div>
        </Container>
        <div className="btn" onClick={this.showComponent}>立即加入#蒲公英计划#</div>
      </Wrapper>
    );
  }
}
export default Home1;